import React from 'react';
import { Icons } from '../components/Icons';
import ProductCard from '../components/UI/ProductCard';
import { CATEGORIES, FEATURED } from '../data/catalog';
import ImageWithFallback from '../components/UI/ImageWithFallback';

const Home = ({ go }) => {
  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div className="hero-bg-pattern" />
        <div className="hero-glow" />
        <div className="hero-inner">
          <div className="hero-left">
            <div className="hero-tag">
              <Icons.CheckCircle size={13} color="#22c55e" />
              Trusted by Global businesses
            </div>
            <h1>The <span>Wholesale</span> Electronics Partner<br />You Can Rely On</h1>
            <p className="hero-desc">Bulk pricing on smartphones, laptops, audio, smart home and more.Worldwide B2B shipping. Dedicated account managers.</p>
            <div className="hero-ctas">
              <button className="btn btn-primary btn-xl" onClick={() => go('products')}>
                <Icons.Package size={18} color="#fff" /> Browse Catalog
              </button>
              <button className="btn btn-xl" style={{ background: 'rgba(255,255,255,.1)', color: '#fff', border: '1.5px solid rgba(255,255,255,.2)' }} onClick={() => go('contact')}>
                Request a Quote
              </button>
            </div>

          </div>
          <div className="hero-right">
            <div className="hero-img-grid">
              <div className="hig-cell">
                <ImageWithFallback src="https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z2FkZ2V0fGVufDB8fDB8fHww" alt="Electronics" loading="eager" />

              </div>
              <div className="hig-cell">
                <ImageWithFallback src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=600&q=85" alt="Smartphones" loading="eager" />
              </div>
              <div className="hig-cell">
                <ImageWithFallback src="https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=600&q=85" alt="Audio" loading="eager" />
                <div className="hig-label">
                  <div className="hig-label-title">Satisfaction Rate</div>
                  <div className="hig-label-val">98.7% ⭐</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* CATEGORIES */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="wrap">
          <div className="section-header center">
            <span className="badge badge-blue"><Icons.Package size={12} /> Product Categories</span>
            <h2 className="sh-title">Shop by Category</h2>
            <p className="sh-sub">Explore our full wholesale catalog across 6 major electronics categories — all available for bulk ordering with competitive B2B pricing.</p>
            <div className="sh-line center" />
          </div>
          <div className="cat-grid">
            {CATEGORIES.map(cat => (
              <div key={cat.id} className="cat-card" onClick={() => go('products')}>
                <div className="cat-card-img">
                  <img src={cat.img} alt={cat.name} loading="lazy" onError={e => { e.target.style.opacity = '0'; }} />
                </div>
                <div className="cat-card-body">
                  <div className="cat-card-name">{cat.name}</div>
                  <div className="cat-card-count">{cat.sub}</div>
                  <div className="cat-card-arrow">
                    <span style={{ fontSize: '.7rem', color: 'var(--gray-400)', fontWeight: 600 }}>{cat.count} products</span>
                    <Icons.ArrowRight size={14} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="section">
        <div className="wrap">
          <div className="why-split">
            <div className="why-img-stack">
              <div className="why-img-main">
                <ImageWithFallback src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=700&q=85" alt="Warehouse operations" />
              </div>
              <div className="why-img-inset">
                <ImageWithFallback src="https://images.unsplash.com/photo-1498049794561-7780e7231661?w=400&q=85" alt="Products" />
              </div>

            </div>
            <div>
              <span className="badge badge-orange">Why NewCover Ltd</span>
              <h2 className="sh-title">The Preferred Wholesale Partner for B2B Buyers</h2>
              <p className="sh-sub">We make sourcing easy, fast, and reliable. From sample orders to container loads — we handle everything so you can focus on selling.</p>
              <div className="sh-line" style={{ marginTop: 16 }} />
              <div className="why-features">
                {[
                  { icon: 'Tag', iconBg: '#2563eb', title: 'Unbeatable Bulk Pricing', desc: '10–40% below retail. Volume tiers reward bigger orders with lower unit costs.' },
                  { icon: 'Shield', iconBg: '#2563eb', title: 'Verified & Certified', desc: 'Only authorized products from genuine distribution channels.' },
                  { icon: 'Zap', iconBg: '#2563eb', title: 'Fast Response Time', desc: 'Dedicated account manager. 24-hour response and same-day dispatch on stock items.' },
                  { icon: 'Globe', iconBg: '#2563eb', title: 'Global Reach & Coverage', desc: 'Multiple countries shipped. Full customs and export documentation.' },
                ].map((feat, i) => {
                  const FIcon = Icons[feat.icon];
                  return (
                    <div key={i} className="why-feature">
                      <div className="why-feature-icon" style={{ background: feat.iconBg }}>
                        <FIcon size={18} color="#fff" />
                      </div>
                      <div>
                        <h4>{feat.title}</h4>
                        <p>{feat.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div style={{ display: 'flex', gap: 12, marginTop: 28 }}>
                <button className="btn btn-primary" onClick={() => go('contact')}>Start Ordering</button>
                <button className="btn btn-white" onClick={() => go('about')}>Learn More</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURED PRODUCTS */}
      <section className="section" style={{ background: 'var(--gray-50)' }}>
        <div className="wrap">
          <div className="section-header" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 24, flexWrap: 'wrap' }}>
            <div>
              <span className="badge badge-blue">Top Sellers</span>
              <h2 className="sh-title">Featured Products</h2>
              <div className="sh-line" style={{ marginTop: 14 }} />
            </div>
            <button className="btn btn-white" onClick={() => go('products')}>
              View Full Catalog <Icons.ArrowRight size={14} />
            </button>
          </div>
          <div className="prod-grid">
            {FEATURED.map(p => <ProductCard key={p.id} product={p} catName={p.cat} go={go} />)}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section">
        <div className="wrap">
          <div className="section-header center">
            <span className="badge badge-blue">Simple Process</span>
            <h2 className="sh-title">How to Order in 5 Steps</h2>
            <p className="sh-sub">From first contact to delivery at your warehouse — our streamlined wholesale process makes B2B buying straightforward.</p>
            <div className="sh-line center" />
          </div>
          <div className="process-steps">
            {[
              { n: '01', title: 'Browse Catalog', desc: 'Explore 10,000+ products across 6 categories and select items you need.' },
              { n: '02', title: 'Request a Quote', desc: 'Submit product names, quantities, and your destination for custom pricing.' },
              { n: '03', title: 'Review Offer', desc: 'Receive detailed pricing, MOQ, and availability within 24 hours.' },
              { n: '04', title: 'Confirm & Pay', desc: 'Approve the proforma invoice and pay via wire, PayPal, or card.' },
              { n: '05', title: 'Receive Goods', desc: 'We dispatch with DHL/FedEx. Track your shipment door-to-door.' },
            ].map((step, i) => (
              <div key={i} className="process-step">
                <div className="ps-num">{step.n}</div>
                <div className="ps-title">{step.title}</div>
                <div className="ps-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA BANNER */}
      <section className="section-sm">
        <div className="wrap">
          <div className="cta-banner">
            <div className="cta-banner-glow" />
            <div className="cta-inner">
              <div>
                <span className="badge badge-navy" style={{ marginBottom: 14 }}>Ready to Start?</span>
                <h2>Place Your First Wholesale Order Today</h2>
                <p>Our B2B team is available Mon–Fri, 9AM–6PM GMT. Average quote turnaround: under 4 hours.</p>
                <div style={{ display: 'flex', gap: 12, marginTop: 28, flexWrap: 'wrap' }}>
                  <button className="btn btn-orange btn-lg" onClick={() => go('contact')}>
                    <Icons.Mail size={17} color="#fff" /> Request a Free Quote
                  </button>
                  <button className="btn btn-lg" style={{ background: 'rgba(255,255,255,.1)', color: '#fff', border: '1.5px solid rgba(255,255,255,.2)' }} onClick={() => go('products')}>
                    Browse Catalog
                  </button>
                </div>
              </div>
              <div className="cta-right">
                {[
                  [<Icons.CheckCircle size={15} color="#22c55e" />, 'No minimum on first sample'],
                  [<Icons.CheckCircle size={15} color="#22c55e" />, 'Reply within 24 hours'],
                  [<Icons.CheckCircle size={15} color="#22c55e" />, 'ISO 9001 Certified supplier'],
                  [<Icons.CheckCircle size={15} color="#22c55e" />, 'Genuine manufacturer warranty'],
                ].map(([icon, text], i) => (
                  <div key={i} className="cta-badge">
                    {icon}<span>{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;